import * as React from 'react';
import React__default, { useState, useEffect } from 'react';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css';
import clsx from 'clsx';
import { shareURLFactory } from '@ta-interaktiv/share-url-factory';
import { postShareSignal, getFacebookAppId, getTwitterHandle, getTitle, getLead } from '@ta-interaktiv/api-access';

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".shareButtons-module_shareItem__-Ae41 {\n  color: var(--muted-text-color);\n}\n.shareButtons-module_shareItem__-Ae41:hover {\n  color: var(--text-color);\n}\n\n.shareButtons-module_shareItem__-Ae41 + .shareButtons-module_shareItem__-Ae41 {\n  margin-left: 1ch;\n}\n\n.shareButtons-module_shareButtons__cqfC0 {\n  font-family: var(--ui-font-stack);\n  display: inline-flex;\n  flex-flow: row;\n  align-items: center;\n}\n.shareButtons-module_shareButtons__cqfC0 button {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: var(--muted-text-color);\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n}\n\n.shareButtons-module_items__Sd-hG {\n  overflow: hidden;\n}\n\n.shareButtons-module_spacer__n5OBE {\n  border-left: 1px solid var(--strong-transparent-black);\n  padding-left: 1ch;\n  display: flex;\n  flex-flow: row;\n  align-items: center;\n  margin-left: 1ch;\n}\n\n.shareButtons-module_openItems__0cPkK {\n  max-width: 100%;\n}\n\n.shareButtons-module_closedItems__8KJAw {\n  max-width: 0;\n}\n\n.shareButtons-module_totalShares__-QbIR {\n  font-size: 0.75rem;\n  margin-top: 0.5ex;\n}";
var styles = {"shareItem":"shareButtons-module_shareItem__-Ae41","shareButtons":"shareButtons-module_shareButtons__cqfC0","items":"shareButtons-module_items__Sd-hG","spacer":"shareButtons-module_spacer__n5OBE","openItems":"shareButtons-module_openItems__0cPkK shareButtons-module_items__Sd-hG","closedItems":"shareButtons-module_closedItems__8KJAw shareButtons-module_items__Sd-hG","totalShares":"shareButtons-module_totalShares__-QbIR"};
styleInject(css_248z);

var socialNetworkNameReplacement = {
    email: 'mail'
};
var getIconName = function (shareType) {
    if (shareType in socialNetworkNameReplacement)
        return socialNetworkNameReplacement[shareType];
    return shareType;
};

function ShareItem(_a) {
    var type = _a.type, shareUrl = _a.shareUrl, _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, className = _a.className, _c = _a.label, label = _c === void 0 ? type : _c;
    return (React.createElement("a", { href: shareUrl, "aria-label": label, className: clsx(styles.shareItem, type, className), onClick: function (e) { return onClick(type, e); }, target: '_top' },
        React.createElement("i", { "aria-hidden": true, className: clsx('icon', getIconName(type)) })));
}

var supportedCommunities = ['twitter', 'facebook', 'whatsapp', 'email'];

function cleanUrl(url) {
    var loc = new URL(url);
    return "" + loc.origin + loc.pathname;
}
function getDefaultUrl() {
    return cleanUrl(window.location.href);
}

var data$1 = { general:{ description:"Diesen Inhalt teilen" },
  twitter:{ name:"Twitter",
    description:"Bei Twitter veröffentlichen" },
  facebook:{ name:"Facebook",
    description:"Auf Facebook teilen" },
  whatsapp:{ name:"WhatsApp",
    description:"Über WhatsApp texten" },
  share:{ name:"Senden",
    description:"Per Mail senden" },
  email:{ name:"eMail",
    description:"Per Mail senden" } };

var data = { general:{ description:"Partager ce contenu" },
  twitter:{ name:"Twitter",
    description:"Publier sur Twitter" },
  facebook:{ name:"Facebook",
    description:"Partager sur Facebook" },
  whatsapp:{ name:"WhatsApp",
    description:"Publier les textes sur WhatsApp" },
  share:{ name:"Envoyer",
    description:"Envoyer par email" },
  email:{ name:"eMail",
    description:"Envoyer par email" } };

var allMessages = {
    de: data$1,
    fr: data
};
var shareThreshold = 30;
function ShareButtons(_a) {
    var _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.url, url = _c === void 0 ? getDefaultUrl() : _c, _d = _a.title, title = _d === void 0 ? window.document.title : _d, clickHandler = _a.clickHandler, _e = _a.className, className = _e === void 0 ? '' : _e, _f = _a.itemClassName, itemClassName = _f === void 0 ? '' : _f, _g = _a.locale, locale = _g === void 0 ? 'de' : _g, _h = _a.lead, lead = _h === void 0 ? '' : _h, _j = _a.twitterHandle, twitterHandle = _j === void 0 ? '' : _j, _k = _a.facebookAppId, facebookAppId = _k === void 0 ? '' : _k, _l = _a.totalShares, totalShares = _l === void 0 ? 0 : _l;
    var _m = useState(false), isOpen = _m[0], toggleOpenState = _m[1];
    var messages = allMessages[locale];
    var numberFormatter = new Intl.NumberFormat(locale + "-CH", {
        notation: 'compact',
        compactDisplay: 'short',
        maximumSignificantDigits: 3
    });
    var shareUrlConfiguration = {
        url: url,
        title: title,
        lead: lead,
        hashtags: hashtags,
        via: twitterHandle,
        facebook_id: facebookAppId
    };
    var handleClicks = function (event) {
        if (navigator.share) {
            navigator
                .share({
                title: title,
                url: url,
                text: title + " \u2013 " + lead
            })
                .then(function () {
                clickHandler('native', event);
            });
        }
        else {
            toggleOpenState(function (prevState) { return !prevState; });
        }
    };
    return (React__default.createElement("div", { className: clsx('ta sharing', styles.shareButtons, className) },
        React__default.createElement("button", { onClick: handleClicks, "aria-label": messages.general.description },
            React__default.createElement("i", { className: clsx('share', 'fitted icon', totalShares < shareThreshold && 'large'), "aria-hidden": true }),
            totalShares >= shareThreshold && (React__default.createElement("div", { className: styles.totalShares }, numberFormatter.format(totalShares)))),
        React__default.createElement("div", { className: clsx(isOpen ? styles.openItems : styles.closedItems) },
            React__default.createElement("div", { className: styles.spacer }, supportedCommunities.map(function (community) {
                if (community === 'facebook' && !facebookAppId) {
                    return null;
                }
                return (React__default.createElement(ShareItem, { label: messages[community].description, onClick: clickHandler, type: community, shareUrl: shareURLFactory[community](shareUrlConfiguration), className: itemClassName, key: community }));
            })))));
}

function notifyBackstage(domainName, articleId, shareType) {
    postShareSignal(domainName, articleId, shareType).then(function () {
        console.debug('[Share Buttons] Notifiying Backstage on %s share', shareType);
    });
}
function notifyGoogleAnalytics(articleId, url, socialNetwork) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        article_id: articleId,
        event: 'Social',
        event_action: 'share',
        event_label: url,
        socialNetwork: socialNetwork
    });
}
function defaultClickHandler(articleId, shareType, domain, url) {
    if (url === void 0) { url = getDefaultUrl(); }
    notifyGoogleAnalytics(articleId, url, shareType);
    notifyBackstage(domain, articleId, shareType);
}

var PolymorphicShareButtons = function (props) {
    var articleId = props.articleId, url = props.url; props.additionalShares; props.hideShareCount;
    var _c = useState(), facebookAppId = _c[0], setFacebookAppId = _c[1];
    var _d = useState(), twitterHandle = _d[0], setTwitterHandle = _d[1];
    var _e = useState(window.document.title), title = _e[0], setTitle = _e[1];
    var _f = useState(), lead = _f[0], setLead = _f[1];
    var domain = parseHostname().publicationName;
    useEffect(function () {
        getFacebookAppId(domain).then(function (id) { return setFacebookAppId(id); });
        getTwitterHandle(domain).then(function (handle) {
            return setTwitterHandle(handle === null || handle === void 0 ? void 0 : handle.replace('@', ''));
        });
        getTitle(domain, articleId).then(function (title) {
            if (title)
                setTitle(title);
        });
        getLead(domain, articleId).then(function (lead) { return setLead(lead); });
    }, [articleId, domain]);
    var clickHandler = function (community, event) {
        props.clickHandler && props.clickHandler(community, event);
        defaultClickHandler(articleId, community, domain, url);
    };
    return (React__default.createElement(ShareButtons, __assign({ facebookAppId: facebookAppId, twitterHandle: twitterHandle, title: title, lead: lead }, props, { clickHandler: clickHandler })));
};

export { ShareButtons as PureShareButtons, PolymorphicShareButtons as ShareButtons, defaultClickHandler, supportedCommunities };
//# sourceMappingURL=index.m.js.map
